<template>
  <CreditCardPayment />
</template>

<script>
import { Cardinal } from "../paypal/cardinal";
import CreditCardPayment from "./CreditCard";

export default {
  name: "PayPalProPayment",

  components: {
    CreditCardPayment,
  },

  props: {
    method: {
      type: Object,
      default: function () {
        return {
          gateway: "creditcard",
          client_side_gateway: {
            name: "PayPal Pro",
            jwt: null,
          },
        };
      },
    },
  },

  mounted() {
    Cardinal.configure({
      logging: {
        level: "on",
      },
    });

    Cardinal.setup("init", {
      jwt: this.method.client_side_gateway.jwt,
    });
    // console.log(window.Cardinal);
  },
};
</script>
